import React from 'react';
import PropTypes from 'prop-types';
import { useFeatureFlag } from '../../hooks/useFeatureFlag';
import { SocialInsuranceForm } from './components/SocialInsuranceForm';
import { SocialInsurances } from './components/SocialInsurances';
export var SocialInsuranceInformation = function SocialInsuranceInformation(_ref) {
  var contact = _ref.contact,
    goToEnrollmentWorkflow = _ref.goToEnrollmentWorkflow,
    groupId = _ref.groupId,
    networkId = _ref.networkId,
    shouldShowLastUpdate = _ref.shouldShowLastUpdate,
    socialInsuranceLastUpdate = _ref.socialInsuranceLastUpdate;
  var showSocialCareCoverage = useFeatureFlag('isPaymentsUser');
  return showSocialCareCoverage && /*#__PURE__*/React.createElement("div", {
    className: "insurance-information"
  }, /*#__PURE__*/React.createElement("div", {
    className: "insurance-information__header",
    "data-testid": "scc-information-header",
    id: "social-insurance-list"
  }, /*#__PURE__*/React.createElement("h3", null, "Social Care Coverage"), /*#__PURE__*/React.createElement(SocialInsuranceForm, {
    contact: contact,
    goToEnrollmentWorkflow: goToEnrollmentWorkflow,
    groupId: groupId,
    networkId: networkId
  })), /*#__PURE__*/React.createElement(SocialInsurances, {
    contactId: contact.id,
    goToEnrollmentWorkflow: goToEnrollmentWorkflow,
    socialInsuranceLastUpdate: socialInsuranceLastUpdate,
    shouldShowLastUpdate: shouldShowLastUpdate
  }));
};
SocialInsuranceInformation.propTypes = {
  contact: PropTypes.object.isRequired,
  goToEnrollmentWorkflow: PropTypes.func.isRequired,
  groupId: PropTypes.string.isRequired,
  networkId: PropTypes.string.isRequired,
  shouldShowLastUpdate: PropTypes.bool,
  socialInsuranceUpdate: PropTypes.shape({
    recently_updated_at: PropTypes.string,
    recently_updated_by_name: PropTypes.string
  })
};
SocialInsuranceInformation.defaultProps = {
  shouldShowLastUpdate: false,
  socialInsuranceLastUpdate: {}
};
//# sourceMappingURL=SocialInsuranceInformation.js.map